import { render, staticRenderFns } from "./TelegramSection.vue?vue&type=template&id=2de91b18&scoped=true"
import script from "./TelegramSection.vue?vue&type=script&lang=js"
export * from "./TelegramSection.vue?vue&type=script&lang=js"
import style0 from "./TelegramSection.vue?vue&type=style&index=0&id=2de91b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de91b18",
  null
  
)

export default component.exports